import * as z from 'zod';

import { brandQueryLinkerSchema } from '@/_pages/settings/brands/shared';
import { emailHistoryQuerySchema } from '@/_pages/settings/email-history/shared/schemas/email-history-query-schema';
import { partnerQueryLinkerSchema } from '@/_pages/settings/partners/shared';
import { companyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';
import { fileQuerySchema } from '@/_schemas/file';
import { currencyInput } from '@/_schemas/generic';

import {
  invoiceAgreementLinkQuerySchema,
  invoiceLatestEmailHistorySchema,
} from './invoice-query-agreement-link-schema';
import { invoiceQueryLinkerSchema } from './invoice-query-linker-schema';

import { executionStatusSchema, invoiceLifecycleStatusSchema } from '../status-options';

export const invoiceQueryLinkerExtendedSchema = z.object({
  ...invoiceQueryLinkerSchema.shape,
  invoice_date: z.string(),
  invoice_batch_id: z.number().nullable(),

  client_id: z.number(),
  client: companyQueryLinkerSchema.nullable(),

  brand_id: z.number().nullable(),
  brand: brandQueryLinkerSchema.nullable(),

  partner_id: z.number().nullable(),
  partner: partnerQueryLinkerSchema.nullable(),

  due_date: z.string().nullable(),
  invoice_amount: currencyInput.querySchema(),
  subtotal_amount: currencyInput.querySchema().nullish(),

  on_account: currencyInput.querySchema().nullish(),
  sub_total: currencyInput.querySchema().nullish(),
  exempt: currencyInput.querySchema().nullish(),
  total: currencyInput.querySchema().nullish(),

  status: invoiceLifecycleStatusSchema.nullable(),

  notes: z.string().nullable(),
  execution_status: executionStatusSchema.nullable(),

  printable_invoices_pdf: z.array(fileQuerySchema).nullish(),
  digital_invoices_pdf: z.array(fileQuerySchema).nullish(),

  is_generating_pdfs: z.boolean().nullish(),

  agreement_links: z.array(invoiceAgreementLinkQuerySchema).nullish(),
  latest_email_history: invoiceLatestEmailHistorySchema.nullable().optional(),
  email_histories: z.array(emailHistoryQuerySchema).nullish(),
});
